import * as React from "react";

const MOBILE_BREAKPOINT = 768;

function viewportIsMobile() {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

export function useIsMobile() {
  // Read the viewport on the first render so a tap before the effect still sees the phone.
  const [isMobile, setIsMobile] = React.useState(viewportIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(viewportIsMobile());
    };
    mql.addEventListener("change", onChange);
    setIsMobile(viewportIsMobile());
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
